import React, { useEffect, useRef } from "react";
import BotMessage from "./BotMessage";
import UserMessage from "./UserMessage";

export default function Messages({ messages }) {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="messages-container">
      {messages.map((msg) => (
        msg.role === "bot" ? (
          <BotMessage key={msg.id} message={msg.content} />
        ) : (
          <UserMessage key={msg.id} text={msg.content} />
        )
      ))}
      <div ref={messagesEndRef} />
      <style>{`
        .messages-container {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
      `}</style>
    </div>
  );
}